/** App_Settings FeatureFlagsCommaSeparated value that unlocks legacy Calc Scripts. */
export const CALC_SCRIPTS_FEATURE_FLAG = 'calcscripts';

/**
 * True when `flagName` is present in UserData.featureFlags.
 * Comparison is trim + case-insensitive (handles mixed-case tokens from SecurityController).
 */
export function isUserFeatureFlagEnabled(
    featureFlags: Array<string | null | undefined> | null | undefined,
    flagName: string
): boolean {
    if (featureFlags == null || flagName == null) {
        return false;
    }

    const target = flagName.trim().toLowerCase();
    if (target.length === 0) {
        return false;
    }

    for (let i = 0; i < featureFlags.length; i++) {
        const flag = featureFlags[i];
        if (flag != null && flag.trim().toLowerCase() === target) {
            return true;
        }
    }

    return false;
}

export function isCalcScriptsFeatureEnabled(
    featureFlags: Array<string | null | undefined> | null | undefined
): boolean {
    return isUserFeatureFlagEnabled(featureFlags, CALC_SCRIPTS_FEATURE_FLAG);
}
